import Camera, { FACING_MODES, IMAGE_TYPES } from './Camera';

export {
  Camera,
  FACING_MODES,
  IMAGE_TYPES
};

export default Camera;



// WEBPACK FOOTER //
// ./src/lib/components/index.js